import {CommonService} from '../../../services/common.service';
import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material';
import {MatDialogRef} from '@angular/material/dialog';
import {ToastMessagesService} from '../../../services/toast-messages.service';

@Component({
  templateUrl: './spare-part-form.component.html'
})
export class SparePartFormComponent implements OnInit {
  edit: boolean;
  part: any;
  partsCategories: any;
  measurementUnits: any;
  title: string;
  selectedCategory: any;
  selectedMeasurement: any;
  description: string;
  alternateId: string;

  constructor(private commonService: CommonService,
              private matDialogRef: MatDialogRef<SparePartFormComponent>,
              private toastMessagesService: ToastMessagesService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.edit = data.edit;
    this.title = data.edit ? 'Ενημέρωση ανταλλακτικού' : 'Προσθήκη νέου ανταλλακτικού';
    if (data.edit) {
      this.part = data.part;
    }
  }

  public async ngOnInit(): Promise<any> {
    await this.initPartsCategories();
    await this.initMeasurementUnits();
    if (!this.edit) {
      this.description = '';
      this.alternateId = '';
    } else {
      this.description = this.part.description;
      this.alternateId = this.part.alternate_id;
      this.selectedCategory = this.partsCategories.find(category => category.id === this.part.category_id);
      this.selectedMeasurement = this.measurementUnits.find(unit => unit.name === this.part.measurement_unit);
    }
  }

  async initPartsCategories() {
    try {
      this.partsCategories = await this.commonService.getList('repair_spare_parts_category');
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  async initMeasurementUnits() {
    try {
      this.measurementUnits = await this.commonService.getList('measurement_unit');
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }


  close(part?) {
    this.matDialogRef.close(part);
  }

  submitPart() {

    const model = this.edit ? {
      id: this.part.id,
      description: this.description,
      category_id: this.selectedCategory.id,
      measurement_unit_id: this.selectedMeasurement.id
    } : {
      alternate_id: this.alternateId,
      description: this.description,
      category_id: this.selectedCategory.id,
      measurement_unit_id: this.selectedMeasurement.id
    };
    this.close(model);
  }

  formInvalid(): boolean {
    return !this.description || !this.alternateId || !this.selectedMeasurement || !this.selectedCategory;
  }
}
